import React, { useState, useEffect } from 'react'
import {
  Table,
  Button,
  Modal,
  Input,
  Space,
  Select,
  Switch,
} from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  SearchOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import axios from 'axios'

import {
  GetFeeAmountMaster,
  CreateFeeAmountMaster,
  UpdateFeeAmountMaster,
  GetFeeMaster,
  DeleteFeeAmountMaster,
} from '../../../AllAPI/AdminAPI'

import { toast } from 'react-toastify'

const FeeAmountMaster = () => {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [fees, setFees] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // useState inputs
  const [feeId, setFeeId] = useState('')
  const [feeAmount, setFeeAmount] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [editingId, setEditingId] = useState(null)

  useEffect(() => {
    fetchFees()
    fetchFeeAmount()
  }, [])

  // Load fees (for dropdown)
  const fetchFees = async () => {
    try {
      const res = await axios.get(
        `${GetFeeMaster}/${storedBranchId}/${BoardingYear}`,
      )
      setFees(res.data)
    } catch (err) {
      toast.error('Failed to load fees')
    }
  }

  // Load subFees
  const fetchFeeAmount = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${GetFeeAmountMaster}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.fee_amt_id,
        index: index + 1,
        fee_amount: item.fee_amount,
        fee_name: item.feeName.fee_name,
        fee_id: item.fee_id,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load Fee Amount')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // Open modal for Add/Edit
  const handleOpenModal = (record = null) => {
    if (record) {
      setEditingId(record.key)
      setFeeId(record.fee_id)
      setFeeAmount(record.fee_amount)
    } else {
      setEditingId(null)
      setFeeId('')
      setFeeAmount('')
    }
    setIsModalOpen(true)
  }

  // Save / Update
  const handleSave = async () => {
    if (!feeId) return toast.error('Please select a Fee')
    if (!feeAmount) return toast.error('Please enter Fee Amount')

    const payload = {
      fee_id: feeId,
      fee_amount: feeAmount,
      branch_id: storedBranchId,
      year: BoardingYear,
    }

    try {
      if (editingId) {
        const res = await axios.put(
          `${UpdateFeeAmountMaster}/${editingId}`,
          payload,
        )
        if (res.data === 'UPDATED') {
          toast.success('Fee Amount updated successfully')
           fetchFeeAmount()
          setIsModalOpen(false)
          setEditingId(null)
          setFeeId('')
          setFeeAmount('')
        } else if (res.data === 'EXIST') {
          toast.warn('Already Exist!')
        }
      } else {
        const res = await axios.post(`${CreateFeeAmountMaster}`, payload)
        if (res.data === 'SAVED') {
          toast.success('Fee Amount added successfully')
          fetchFeeAmount()
          setIsModalOpen(false)
          setEditingId(null)
          setFeeId('')
          setFeeAmount('')
        } else if (res.data === 'EXIST') {
          toast.warn('Already Exist!')
        } else if (res.data === 'INVALIDAMOUNT') {
          toast.warn('Invalid Amount!')
        }
      }

    } catch (err) {
      toast.error('Failed to save Fee Amount')
    }
  }

  const handleDelete = async (id) => {
    try {
      const res = await axios.delete(`${DeleteFeeAmountMaster}/${id}`)
      if (res.data === 'NOTFOUND') {
        toast.warn('Fee Amount not found!')
        fetchFeeAmount()
      } else if (res.data === 'DELETED') {
        toast.success('Fee Amount deleted successfully')
        fetchFeeAmount()
      }
    } catch (err) {
      toast.error('Failed to delete Fee Amount')
    }
  }

  const openDeleteModal = (id) => {
    setDeleteId(id)
    setIsDeleteModalOpen(true)
  }

  const confirmDelete = async () => {
    await handleDelete(deleteId)
    setIsDeleteModalOpen(false)
    setDeleteId(null)
  }

  // Search filter
  const filteredData = data.filter((item) =>
    (item.fee_name + '').toLowerCase().includes(searchText.toLowerCase()),
  )

  const columns = [
    { title: 'Sr No', dataIndex: 'index' },
    { title: 'Fee', dataIndex: 'fee_name' },
    { title: 'Fee Amount', dataIndex: 'fee_amount' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
          <Button
            icon={<DeleteOutlined />}
            danger
            size="small"
            onClick={() => openDeleteModal(record.key)}
          />
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Fee Amount Master</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search fee amount..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />

            <Button
              
              className="addButton mt-2 mt-md-0"
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal()}
              style={{ marginLeft: 10 }}
            >
              Add Fee Amount
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            className='shadow border rounded'
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* MODAL */}
      <Modal
        title={editingId ? 'Edit Fee Amount' : 'Add Fee Amount'}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" className='addButton'  onClick={handleSave}>
            Save
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 15 }}>
          <label>Select Fee</label>
          <Select
            value={feeId}
            onChange={setFeeId}
            placeholder="Select Fee"
            style={{ width: '100%' }}
            disabled={!!editingId}
          >
            {fees.map((f) => (
              <Select.Option key={f.fee_id} value={f.fee_id}>
                {f.fee_name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <label>Fee Amount</label>
          <Input
            placeholder="Enter amount"
            min={0}
            value={feeAmount}
            onChange={(e) => setFeeAmount(e.target.value)}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault()
              }
            }}
          />
        </div>
      </Modal>

      {/* ===DELETE MODAL==== */}
      <Modal
        title="Confirm Delete"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsDeleteModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="delete"  danger type="primary" onClick={confirmDelete}>
            Delete
          </Button>,
        ]}
      >
        <p>Are you sure you want to delete this fee amount?</p>
      </Modal>
    </div>
  )
}

export default FeeAmountMaster
